import { LogMapper, mappingResults } from './mappers/base'
import { ActivityLogbook } from '@/models/ScientificActivity'

export class ScientificActivityMapper extends LogMapper {
  static rows = ['logbook']
  static specialty = 'scientificActivity'
  static columns = ['authors']

  static components = {
    'logbook': {
      options: () => (ActivityLogbook.query().get().map(mappingResults)),
      checker: this.basicChecker
    },
    'authors': {
      options: this.standardOptions,
      checker: (log, _, option) => (log['authorship'] === option.value)
    }
  }
}

